import { Component, Input, OnInit } from '@angular/core';
import {
  AlertController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { PlainScorecard, PlayerRoundScores } from 'src/data/handicap-history';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { getNestedValue } from 'src/providers/common-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { Router } from '@angular/router';
import { DeleteAccountModalComponent } from './delete-account-modal/delete-account-modal.component';
import {
  CompetitionData,
  CustomizedAttributes,
  LeagueSeason,
  PlayerHomeInfo,
  PlayerInfo,
} from 'src/data/mygolf.data';
import { finalize, Subscription, Observable } from 'rxjs';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CompetitionService } from 'services/competition-service/competition-service';
import { CommonPullupMenuComponent } from '../common-pullup-menu/common-pullup-menu.component';
import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { Browser } from '@capacitor/browser';
import * as globals from 'src/globals';
import { TextValidator } from 'src/custom/field-validator';

@Component({
  selector: 'app-competition-form',
  templateUrl: './competition-form.page.html',
  styleUrls: ['./competition-form.page.scss'],
})
// export interface CompetitionSignUp {
//     playerMappingForms: {
//       fullName?: string;
//       HandicapIndex?: string;
//       whsNumber?: string;
//       contactNumber?: string;
//       gender?: string;
//       email?: string;
//       icNumber?: string;
//     };
//     updatePlayerMapping: {

//     };
//     updateCompPlayerMapping: {
//       TShirtSize: 'updateShirtSize',
//       HandicapIndex: 'updateHandicapIndex',

//     }

// }
export class CompetitionFormModalPage implements OnInit {
  public title: string;
  public descriptionText: string;
  public headerName: string;
  public scorecard: PlainScorecard;

  myTime: any = moment();
  teeTime: Date = new Date(); //string; //Date = new Date();
  prevTeeTime: Date; // = new Date();
  myTDate: string; //Date;// = new Date();
  prs: PlayerRoundScores;
  prevTdate: string;

  accountDeletionType: string = 'deactivate';

  appAttribute: any;
  accountDeactivateAtt: any;
  accountDeleteAtt: any;
  accountDeleteSuccessMessage: any = '';

  // Track subscriptions for cleanup to prevent memory leaks
  private updateSubscriptions: Subscription[] = [];

  @Input() formDefinition: any;
  @Input() formId: any;
  @Input() playerAdditionalInfo: any;
  @Input() compData: CompetitionData;
  @Input() player: any; //PlayerHomeInfo;
  @Input() requireMandatory: boolean = false;
  @Input() viewMode: boolean = false;
  @Input() sctOrMct: string = 'sct';
  @Input() leagueSeason: LeagueSeason;
  @Input() allowedForms: Array<string>;
  @Input() titleHeader: string = null;
  @Input() formFirstRegister: boolean = false;
  constructor(
    public nav: NavController,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private router: Router,
    private toastCtl: ToastController,
    private platform: Platform,
    private mg2uUtil: mygolfUtils,
    private alertCtrl: AlertController,
    private flightService: ClubFlightService,
    private compService: CompetitionService,
    private customizerService: AppCustomizerService
  ) {
    this.title = this.navParams.get('title');
    this.descriptionText = this.navParams.get('description');
    this.headerName = this.navParams.get('headerName');
    this.scorecard = this.navParams.get('scorecard');
    this.appAttribute = this.mg2uUtil.getAppAttribute();

    this.teeTime = this.myTime;

    this.prevTeeTime = this.teeTime;
    this.prevTdate = this.myTDate;

    if (this.appAttribute) {
      this.appAttribute
        .filter(att => att.page === 'accountOptions')
        .map(att => {
          console.log('7777777777', att);

          if (att && att.deactivate) {
            this.accountDeactivateAtt = att.deactivate;
          }
          console.log('this.accountDeactivateAtt: ', this.accountDeactivateAtt);
          if (att && att.delete) {
            this.accountDeleteAtt = att.delete;
          }
          console.log('this.accountDeleteAtt: ', this.accountDeleteAtt);
          if (att && att.processedMessage) {
            this.accountDeleteSuccessMessage = att.processedMessage;
          }
        });
    }

    this.customizerService.getSubsidiary().subscribe(subsidiary => {
      if (globals.appType === 'main') {
      } else {
        this.currentSubsidiary = subsidiary;
      }
    });
  }
  playerIsRegistered: boolean = false;
  currentSubsidiary: string;
  async ngOnInit() {
    await this.getCustomizedAttributes();
    await this.getPlayerDetails();
    if (this.formDefinition) {
      // const sourceFormDefinition = JSON.parse(this.formDefinition);
      const formDef = JSON.parse(JSON.stringify(this.formDefinition));
      this.compAddlInfoForm = this.constructDynamicForms(formDef);

      console.debug(
        'comp form : ',
        this.compAddlInfoForm,
        this.formDefinition,
        this.playerAdditionalInfo
      );
      this.parseFormDefinition();
    }
    if (!this.playerAdditionalInfo) {
      this.initPlayerForm();
    } else {
      this.populatePlayerForm();
    }
  }

  close() {
    this.myTDate = this.prevTdate;
    this.teeTime = this.prevTeeTime;
    this.modalCtl.dismiss(null);
  }

  onApplyClick() {
    if (1) {
      return false;
    }
    let valid: boolean = true;
    let currentDate = moment().format('YYYY-MM-DD');
    let currentTime = moment().format('HH:mm');

    let selDate = moment(this.myTDate).format('YYYY-MM-DD');
    let selTime = moment(this.teeTime).format('HH:mm');

    console.log('apply click current date/time:', currentDate, ',', currentTime);
    console.log('apply click selected date/time:', selDate, ',', selTime);

    this.scorecard.playedOn = this.myTDate;

    if (selDate > currentDate) {
      valid = false;
    } else if (selDate == currentDate && selTime > currentTime) {
      valid = false;
    }

    if (!valid) {
      let subTitle = 'Please set tee-off date and time in the past or today';
      MessageDisplayUtil.showErrorToast(subTitle, this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }

    if (this.scorecard.playerRoundScores.length > 0) {
      this.scorecard.playerRoundScores.forEach((prs: PlayerRoundScores) => {
        if (!prs.actualStartTime) {
          prs.actualStartTime = moment(this.teeTime, 'HH:mm').format('HH:mm');
        }

        if (!prs.startTime) {
          console.log('valid Time');
          prs.startTime = moment(this.teeTime, 'HH:mm').format('HH:mm');
        } else {
          console.log('else');
          prs.startTime = moment(this.teeTime, 'YYYY-MM-DDTHH:mm:ssZ').format('HH:mm');
        }
      });
    }

    this.modalCtl.dismiss({ scorecard: this.scorecard });
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  onClickCancel() {
    this.modalCtl.dismiss();
    //   this.nav.pop();
  }

  async onClickProceed() {
    let _accountDeletionType = '';
    if (this.accountDeletionType === 'deactivate') {
      _accountDeletionType = 'deactivating';
    } else if (this.accountDeletionType === 'delete') {
      _accountDeletionType = 'deleting';
    }
    let _message = 'Do you want to proceed with ' + _accountDeletionType + ' your account?';
    const modal = await this.modalCtl.create({
      component: DeleteAccountModalComponent,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      mode: 'ios',
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.goAccountDeletion();
      }
    });
    //   let alert =await this.alertCtrl.create({
    //       header: 'Confirmation',
    //       message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
    //       buttons: [{
    //           text: 'No'
    //       },{
    //           text: 'Yes',
    //           handler: () => {
    //               this.goAccountDeletion();
    //           }
    //       }]
    //   });
    //   alert.present();
  }

  goAccountDeletion() {
    let _msg = '';
    const self = this;
    this.flightService.userRequestAccountDeletion().subscribe({
      next(result) {
        if (result) {
          _msg =
            'Successfully requested for account deletion. This process might take 6-7 days to process';
        } else {
          _msg = 'There was an error. Please try again after a few moments.';
        }
      },
      error() {
        _msg = 'There was an error. Please try again after a few moments.';
      },
      async complete() {
        const modal = await self.modalCtl.create({
          component: DeleteAccountModalComponent,
          cssClass: self.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            modeFrom: 'confirmDelete',
            msg: _msg,
          },
          mode: 'ios',
        });
        await modal.present().then(() => {
          const height = self.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });

        modal.onDidDismiss().then(data => {
          console.debug('dismiss submit acount deletion request', data);
          setTimeout(() => {
            self.modalCtl.dismiss();
          }, 500);
        });
      },
    });

    //   .subscribe((result)=>{
    //       console.debug("request account deletion : ", result)
    //       if(result) {
    //            _msg = 'Successfully requested for account deletion. This process might take 6-7 days to process';
    //           if(this.accountDeleteAtt && this.accountDeleteAtt.processedMessage) _msg = this.accountDeleteAtt.processedMessage;

    //         //   MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');

    //           this.modalCtl.dismiss({needRefresh: true});
    //       } else {
    //         _msg = 'There was an error. Please try again after a few moments.'
    //         //   MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');
    //       }
    //   },(error)=>{
    //       if(error) {
    //         _msg = 'There was an error. Please try again after a few moments.'
    //         // MessageDisplayUtil.showErrorToast(_msg,this.platform, this.toastCtl,3000, 'bottom');
    //       }
    //   })
  }

  goCheckNHSNumber() {
    const url = 'http://nhs.mgaonline.com.my/';
    window.open(url, '_system');
  }

  subUpdateAddInfo: Subscription;
  validateMessage: string[] = [];
  async onValidateForm() {
    this.validateMessage = [];
    try {
      let _validate: boolean = true;
      if (this.playerForm) {
        // await this.compAddInfoForm?.formObj.fields.forEach(fld => {
        await this.formDefinition?.fields.forEach(fld => {
          const _playerField = this.playerForm[fld.name];
          if (
            fld.required &&
            (this.playerForm[fld.name]?.length === 0 ||
              this.playerForm[fld.name] === null ||
              this.playerForm[fld.name] === undefined ||
              this.playerForm[fld.name]?.toLowerCase() === 'null' ||
              TextValidator.isBlank(this.playerForm[fld.name]))
          ) {
            // console.debug(
            //   'validate add info [0]: ',
            //   fld,
            //   this.playerAdditionalInfo[fld.name]?.length
            // );
            this.validateMessage.push(`${fld.label} is mandatory`);
            _validate = false;
          }
          // if (
          //   fld.required &&
          //   fld.type === 'options' &&
          //   (TextValidator.isBlank(_playerField) || _playerField?.toLowerCase() === 'null')
          // ) {
          //   this.validateMessage.push(`${fld.label} is AA mandatory`);
          //   _validate = false;
          // }
          if (
            fld.required &&
            fld.type === 'text' &&
            (TextValidator.isOnlyZeros(_playerField) || TextValidator.contains000(_playerField))
          ) {
            this.validateMessage.push(`${fld.label} is invalid`);
            _validate = false;
          }
          if (
            fld.required &&
            fld.type === 'text' &&
            (fld.label?.toLowerCase()?.includes('phone') ||
              fld.label?.toLowerCase().includes('contact'))
          ) {
            if (!TextValidator.isValidPhone(_playerField, 8, 15)) {
              this.validateMessage.push(`${fld.label} is invalid`);
              _validate = false;
            }
          }
          console.debug('validating form fields : ', fld, this.playerForm, this.compAddlInfoForm);
          this.playerForm[fld.name] = this.playerForm[fld.name].toUpperCase();
        });
      }
      return _validate;
    } catch (error) {
      return true;
    }
  }
  proceedSubmit() {
    console.debug(
      'on submit : ',
      this.formDefinition,
      this.player,
      this.playerForm,
      this.playerAdditionalInfo,
      this.sctOrMct,
      this.appAttribute,
      this.compService.getPlayerIsRegistered()
    );
    // for(const field of this.playerForm) {
    //   if(typeof this.playerForm[field]=== 'string') {
    //     this.playerForm[field] = this.playerForm[field].toUpperCase();
    //   }

    // }

    if (this.sctOrMct === 'mct') {
      const playerId = this.player?.playerId || this.player?.id;
      this.flightService
        .updateMCTPlayerAdditionalInfo(
          this.leagueSeason?.league?.organizer?.id,
          this.leagueSeason?.id,
          playerId,
          this.playerForm
        )
        .subscribe(data => {
          this.onProceedPlayerUpdates();
        });
      this.modalCtl.dismiss(true);
    } else {
      // this.subUpdateAddInfo = this.compService
      //   .getPlayerIsRegistered()
      //   .pipe(
      //     finalize(() => {
      //       if (this.subUpdateAddInfo) {
      //         this.subUpdateAddInfo.unsubscribe();
      //         this.subUpdateAddInfo = null;
      //       }
      //       this.playerForm = null;
      //     })
      //   )
      //   .subscribe(playerIsRegistered => {
      //     if (playerIsRegistered) {
      const playerId = this.player?.playerId || this.player?.id;
      if (this.formFirstRegister) {
        this.compService.getPlayerIsRegistered().subscribe(isRegistered => {
          if (isRegistered) {
            this.flightService
              .updateCompPlayerAdditionalInfo(this.compData?.id, playerId, this.playerForm)
              .subscribe(data => {
                this.onProceedPlayerUpdates();
                this.onProceedCompUpdates();
                this.compService.setPlayerIsRegistered(false);
              });
          }
        });
      } else {
        this.flightService
          .updateCompPlayerAdditionalInfo(this.compData?.id, playerId, this.playerForm)
          .subscribe(data => {
            this.onProceedPlayerUpdates();
            this.onProceedCompUpdates();
            this.compService.setPlayerIsRegistered(false);
          });
      }
      //   }
      // });

      this.modalCtl.dismiss({
        proceedRegister: true,
      });
    }
  }
  async onClickSubmit() {
    let _validateSuccess: boolean = true;
    if (this.requireMandatory) {
      _validateSuccess = await this.onValidateForm();
      if (_validateSuccess) {
        this.proceedSubmit();
      } else {
        MessageDisplayUtil.showErrorToast(
          this.validateMessage.join('<br>'),
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
      }
    } else {
      this.proceedSubmit();
    }
  }

  playerForm: any = {};
  initPlayerForm() {
    // if (!this.formDefinition) return;
    // if (this.formDefinition?.fields?.length) {
    //   this.formDefinition.fields?.forEach(fld => {
    //     if (fld.type !== 'separator') {
    //       this.playerForm[fld.name] = null;
    //     }
    //   });
    // }
    if (!this.formDefinition) {
      return;
    }
    let competitionSignUp;

    if (this.appAttribute) {
      competitionSignUp = this.appAttribute.find(
        att => att.page === 'competition'
      )?.competitionSignUp;
    }
    // console.debug(
    //   'init player form : ',
    //   this.appAttribute.find(att => att.page === 'competition'),
    //   competitionSignUp
    // );
    let playerMapping;
    if (globals.appType === 'main') {
      playerMapping = competitionSignUp?.playerMappingForms;
    } else {
      playerMapping = this.customizedAttributes?.competitionSignUp?.playerMappingForms;
    }
    const _player = this.player;
    console.debug('init player form : ', playerMapping, this.player, _player, this.formDefinition);
    // const _playerAddlInfo = Object.assign(this.playerAdditionalInfo);
    const _fields = this.formDefinition.fields;
    _fields.forEach(fld => {
      if (fld.type !== 'separator') {
        const mappedPath = playerMapping?.[fld.name];
        const playerValue = mappedPath ? getNestedValue(_player, mappedPath) : undefined;

        if (playerValue !== undefined) {
          this.playerForm[fld.name] = playerValue;
        } else {
          if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
            console.debug(
              'each field populate [0]',
              fld,
              _player[playerMapping[fld.name]],
              _player
            );
          }
          // Initialize datetime fields with undefined instead of null to avoid ion-datetime errors
          // ion-datetime cannot handle empty strings - use undefined for no value
          if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
            this.playerForm[fld.name] = undefined;
          } else {
            this.playerForm[fld.name] = null;
          }
        }
      }
      // if (_playerAddlInfo[fld.name]) {
      //   this.playerForm[fld.name] = _playerAddlInfo[fld.name];
      // } else if (_player[playerMapping[fld.name]]) {
      //   this.playerForm[fld.name] = _player[playerMapping[fld.name]];
      // } else this.playerForm[fld.name] = null;
    });
  }
  populatePlayerForm() {
    if (!this.playerAdditionalInfo) {
      return;
    }
    const playerMapping = this.customizedAttributes?.competitionSignUp?.playerMappingForms;
    const _player = this.player;
    const _playerAddlInfo = Object.assign(this.playerAdditionalInfo);
    const _fields = this.formDefinition.fields;
    _fields.forEach(fld => {
      if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
        console.debug('each field populate [1]', fld, _playerAddlInfo[fld.name], _player);
      }
      if (_playerAddlInfo[fld.name]) {
        this.playerForm[fld.name] = _playerAddlInfo[fld.name];
      } else if (playerMapping) {
        const mappedPath = playerMapping[fld.name];
        const playerValue = mappedPath ? getNestedValue(_player, mappedPath) : undefined;

        if (playerValue !== undefined) {
          this.playerForm[fld.name] = playerValue;
        } else {
          // Initialize datetime fields with undefined instead of null to avoid ion-datetime errors
          // ion-datetime cannot handle empty strings - use undefined for no value
          if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
            this.playerForm[fld.name] = undefined;
          } else {
            this.playerForm[fld.name] = null;
          }
        }
      } else {
        // Initialize datetime fields with undefined instead of null to avoid ion-datetime errors
        // ion-datetime cannot handle empty strings - use undefined for no value
        if (fld.type === 'time' || fld.type === 'date' || fld.type === 'datetime') {
          this.playerForm[fld.name] = undefined;
        } else {
          this.playerForm[fld.name] = null;
        }
      }

      if (fld.type === 'file' && fld?.properties?.image) {
        console.debug('populate image field : ', fld, _playerAddlInfo);
        if (this.temporaryImageURL[fld.name] === undefined) {
          this.temporaryImageURL[fld.name] = null;
        }
        this.temporaryImageURL[fld.name] = globals.MygolfServer + '/' + _playerAddlInfo[fld.name];
      }
      // console.debug('populating form [00]', fld, _playerAddlInfo, _player, playerMapping);
      // console.debug(
      //   'populating form [000]',
      //   fld.name,
      //   _playerAddlInfo[fld.name],
      //   _player[playerMapping[fld.name]],
      //   playerMapping[fld.name]
      // );
    });
    // for (let [key, value] of Object.entries(this.playerAdditionalInfo)) {
    //   if (!this.playerForm[key] || this.playerForm[key] === undefined) {
    //     this.playerForm[key] = null;
    //   }

    //   if (!value) {
    //     for (let [key2, value2] of Object.entries(playerMapping)) {
    //       console.debug(
    //         'populating form from attributes ',
    //         playerMapping,
    //         key,
    //         value,
    //         key2,
    //         value2
    //       );
    //       if (key2 === key) {
    //         // this.playerForm[key2] = this.player[value2];
    //       }
    //     }
    //   } else this.playerForm[key] = value;
    //   console.debug(
    //     'populating form [0]',
    //     key,
    //     value,
    //     this.formDefinition,
    //     this.playerAdditionalInfo,
    //     this.playerForm,
    //     this.playerAdditionalInfo[key],
    //     this.playerForm[key],
    //     playerMapping
    //   );
    // }
  }

  parseTextWithLinks(text: string): string {
    if (!text) {
      return '';
    }

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(
      urlRegex,
      url => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  }

  clonedFormDefinition;
  parseFormDefinition() {
    this.clonedFormDefinition = null;
    this.clonedFormDefinition = JSON.parse(JSON.stringify(this.formDefinition));
    if (this.clonedFormDefinition?.fields?.length) {
      this.clonedFormDefinition.fields.forEach(fld => {
        fld.hint = this.parseTextWithLinks(fld.hint);
        fld.tooltip = this.parseTextWithLinks(fld.tooltip);
      });
    }
  }

  async onClickTooltip(field) {
    let _message = {
      title: field?.label,
      content: field?.tooltip,
    };

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        message: _message,
        mode: 'infoDisplay',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {});
  }

  customizedAttributes: CustomizedAttributes;
  getCustomizedAttributes() {
    this.customizerService.getCustomizedAttributes().subscribe(data => {
      if (data) {
        this.customizedAttributes = data;
        if (this.customizedAttributes?.competitionSignUp?.requireMandatory !== undefined) {
          const requireMandatory = this.customizedAttributes?.competitionSignUp?.requireMandatory;
          if (requireMandatory) {
            this.requireMandatory = requireMandatory;
          }
        }
      }
      console.debug('get customized attributes : ', data, this.customizedAttributes);
    });
  }
  // ionViewWillEnter() {
  //   this.backButtonSub = this.platform.backButton.subscribeWithPriority(9999, () => {
  //     this.modalCtrl.dismiss();
  //   });
  // }

  ionViewWillLeave() {
    // Unsubscribe from all pending requests to prevent memory leaks
    this.updateSubscriptions.forEach(sub => sub.unsubscribe());
    this.updateSubscriptions = [];
  }
  getDateTimeDisplayFormat(field) {
    if (!field) {
      return 'YYYY-MM-DD HH:mm';
    }
    if (field?.type === 'time') {
      return 'HH:mm';
    } else if (field?.type === 'date') {
      return 'YYYY-MM-DD';
    } else if (field?.type === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }
  }
  getDateTimePickerFormat(field) {
    if (!field) {
      return 'YYYY-MM-DD HH:mm';
    }
    if (field?.type === 'time') {
      return 'HH:mm';
    } else if (field?.type === 'date') {
      return 'YYYY-MM-DD';
    } else if (field?.type === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }
  }
  getDateTimeValueFormat(field) {
    if (!field) {
      return 'YYYY-MM-DD HH:mm';
    }
    if (field?.type === 'time') {
      return 'HH:mm';
    } else if (field?.type === 'date') {
      return 'YYYY-MM-DD';
    } else if (field?.type === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }
  }

  compAddlInfoForm: any;
  constructDynamicForms(data: any) {
    const groupedData = [];
    let currentGroup = null;

    // Create a default group for fields before the first separator
    currentGroup = {
      name: 'additionalInfo',
      display: data.title,
      description: '',
      fields: [],
    };
    groupedData.push(currentGroup);

    data.fields.forEach(field => {
      if (field.type === 'separator') {
        currentGroup = {
          name: field.name,
          display: field.properties.sectionTitle,
          description: field.properties.sectionDescription,
          fields: [],
        };
        groupedData.push(currentGroup);
      } else {
        if (field?.hint) {
          field.hint = this.parseTextWithLinks(field.hint);
        }
        if (field?.tooltip) {
          field.tooltip = this.parseTextWithLinks(field.tooltip);
        }
        // This handles the case where the first fields are not under a separator
        if (currentGroup) {
          currentGroup.fields.push(field);
        }
      }
    });

    return groupedData;
  }

  temporaryImageURL: any = {};

  async takePhotoFromGallery(event, field) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    // this.selectedFiles = event.target.files[0];
    this.playerForm[field.name] = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    //

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
      console.debug('take photo from gallery : ', filesAmount, images, event);
      this.temporaryImageURL[field.name] = event.target.files[0].name;
      const _tmpFile = event.target.files[0];
      // this.previewImage = images;

      // if (this.selectedFiles && mode === 'update')
      //   this._uploadImage(this.temporaryImageURL);

      let preview = document.getElementById(`preview-${field.name}`) as HTMLImageElement;
      this.tmpFilename[field.name] = _tmpFile?.name;
      if (_tmpFile.type.startsWith('image/')) {
        // ✅ It's an image — show preview
        preview.src = URL.createObjectURL(_tmpFile);
        preview.style.display = 'block';
        preview.onload = () => URL.revokeObjectURL(preview.src);
      } else {
        // ❌ Not an image — show a placeholder icon based on file type
        preview.style.display = 'block';
        preview.onload = null;

        if (_tmpFile.type === 'application/pdf') {
          preview.src = 'assets/icons/pdf-file.png';
        } else if (_tmpFile.type.startsWith('video/')) {
          preview.src = 'assets/icons/video-file.png';
        } else if (_tmpFile.type.includes('word') || _tmpFile.type.includes('document')) {
          preview.src = 'assets/icons/doc-file.png';
        } else {
          preview.src = 'assets/icons/file-icon.png'; // generic fallback
        }
      }
      // preview.src = URL.createObjectURL(_tmpImage); // 👈 creates a blob: URL
      // preview.style.display = 'block';

      // // ⚠️ Important: revoke the object URL after use to free memory
      // preview.onload = () => URL.revokeObjectURL(preview.src);
    }
  }
  tmpFilename: any = {};
  deleteImage(field) {
    this.temporaryImageURL[field.name] = null;
    // if(this.playerDiscountProgram?.document){
    //    this.playerDiscountProgram.document = null;
    // }
  }
  onProceedPlayerUpdates() {
    console.debug('proceed player updates [0] ', this.player);
    console.debug('proceed player updates [1]', this.playerForm);
    console.debug('proceed player updates [2]', this.appAttribute);

    if (!this.appAttribute) {
      return;
    }

    const competitionSignUp = this.appAttribute.find(
      att => att.page === 'competition'
    )?.competitionSignUp;

    if (!competitionSignUp?.updatePlayerMapping) {
      return;
    }

    // Use spread operator for cleaner shallow copy
    const playerMapping = { ...competitionSignUp.updatePlayerMapping };

    // Build fields to update using Object.entries for proper object iteration
    const fieldsToUpdate: Record<string, any> = {};

    for (const [key, _] of Object.entries(playerMapping)) {
      if (this.playerForm[key] !== undefined) {
        // Removed unnecessary await - this is synchronous
        fieldsToUpdate[playerMapping[key]] = this.playerForm[key];
      }
    }
    this.goProcessPlayerUpdate(fieldsToUpdate, playerMapping);

    // get plyer home info
    // (this.playerHomeActions
    //   .updatePlayerProfile(this.player, friend)
    //   .subscribe((result: boolean) => {
    // })
  }
  async onProceedCompUpdates() {
    if (!this.appAttribute) {
      return;
    }

    const competitionSignUp = this.appAttribute.find(
      att => att.page === 'competition'
    )?.competitionSignUp;

    if (!competitionSignUp?.updateCompPlayerMapping) {
      return;
    }

    // Use spread operator for cleaner shallow copy
    const compMapping = { ...competitionSignUp.updateCompPlayerMapping };

    // Build fields to update using Object.entries for proper object iteration
    const fieldsToUpdate: Record<string, any> = {};

    for (const [key, _] of Object.entries(compMapping)) {
      if (this.playerForm[key] !== undefined) {
        // Removed unnecessary await - this is synchronous
        fieldsToUpdate[key] = this.playerForm[key];
      }
    }

    // Check if there are actually fields to update
    if (Object.keys(fieldsToUpdate).length === 0) {
      console.debug('No fields to update for competition player');
      return;
    }

    this.goProcessCompUpdate(fieldsToUpdate, compMapping);
  }

  goProcessCompUpdate(fieldsToUpdate: Record<string, any>, compMapping: Record<string, string>) {
    const compId = this.compData?.id;
    const playerId = this.player?.playerId || this.player?.id;

    if (!compId || !playerId) {
      console.error('Missing compId or playerId for update');
      return;
    }

    const playerIds = [playerId];
    const updateRequests: Array<Observable<any>> = [];

    // Collect all update requests
    for (const [key, updateType] of Object.entries(compMapping)) {
      const value = fieldsToUpdate[key];
      if (value === undefined) {
        continue;
      }

      switch (updateType) {
        case 'updateShirtSize':
          updateRequests.push(
            this.flightService.updateCompPlayerShirtSize(compId, playerIds, value)
          );
          break;
        case 'updateHandicapIndex':
          updateRequests.push(
            this.flightService.updateCompPlayerHandicapIndex(compId, playerId, Number(value))
          );
          break;
        default:
          console.warn(`Unknown update type: ${updateType}`);
      }
    }

    if (updateRequests.length === 0) {
      console.debug('No valid update requests to execute');
      return;
    }

    // Execute all updates in parallel using forkJoin
    const subscription = forkJoin(updateRequests)
      .pipe(
        catchError(error => {
          console.error('Error updating competition player:', error);
          MessageDisplayUtil.showErrorToast(
            error.status || 'UPDATE_FAILED',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return of(null); // Return observable to prevent error propagation
        })
      )
      .subscribe({
        next: results => {
          console.debug('Competition player updates completed:', results);
        },
        complete: () => {
          // Cleanup handled by ionViewWillLeave
        },
      });

    this.updateSubscriptions.push(subscription);
  }

  goProcessPlayerUpdate(
    fieldsToUpdate: Record<string, any>,
    playerMapping: Record<string, string>
  ) {
    const playerId = this.player?.playerId || this.player?.id;
    console.debug('proceed player updates [3]', fieldsToUpdate);
    if (!playerId) {
      console.error('Missing playerId for update');
      return;
    }
    let _params = this.player;

    for (const [key, value] of Object.entries(fieldsToUpdate)) {
      // const value = fieldsToUpdate[playerMapping[key]];
      if (value === undefined) {
        continue;
      }
      _params[key] = value;
    }

    this.flightService.updatePlayerProfile(playerId, _params).subscribe(data => {
      console.debug('done update player profile ', this.playerForm, this.player, _params, data);
    });
  }

  getPlayerDetails() {
    const playerId = this.player?.playerId || this.player?.id;
    this.flightService.getPlayerDetails(playerId).subscribe(playerDetails => {
      this.player = playerDetails;
    });
  }
  onKeyupEvent(event, field) {
    this.playerForm[field.name] = this.playerForm[field.name].toUpperCase();
  }

  onClickViewFile(filename: string) {
    const url = `${globals.MygolfServer}/${filename}`;
    Browser.open({ url: url });
  }

  getFilename(filename: string) {
    const _filename = filename.split('/')[6].split('?')[0];
    return _filename;
  }
  isFileImage(filename: string) {
    return (
      filename?.toLowerCase()?.includes('.png') ||
      filename?.toLowerCase()?.includes('.jpeg') ||
      filename?.toLowerCase()?.includes('.jpg')
    );
  }
  isFilePdf(filename: string) {
    return filename?.toLowerCase()?.includes('.pdf');
  }
  isAllowedForm(formName: string) {
    if (!this.allowedForms) {
      return true;
    }
    if (!this.allowedForms?.length) {
      return true;
    }
    return this.allowedForms?.find(form => form === formName);
  }
}
